import React, { FC } from 'react';
import { graphql } from 'gatsby';

import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';
import {
  CustomField,
  CustomImg,
  CustomLabel,
  CustomLink,
  PendingTitle,
} from '../styled';

import orderPending from '../../../../static/images/alert-triangle@2x.png';

interface Props {
  txid: string;
  status: string;
}

const Pending: FC<
  Props &
    Queries.ThankYouPendingFragment &
    Queries.ThankYouCommonFragment &
    Queries.ThankYouFailedFragment
> = ({ txid, status, content, links, pending, failed }) => {
  return (
    <>
      <CustomImg src={orderPending} alt="Order On Hold" />
      <PendingTitle>{pending?.title}</PendingTitle>
      {txid && status && (
        <div style={{ textAlign: 'left' }}>
          <CustomLabel>{content?.labels?.transaction}</CustomLabel>
          <CustomField>{txid}</CustomField>
          <CustomLabel>{content?.labels?.status}</CustomLabel>
          <CustomField>{status}</CustomField>
        </div>
      )}
      <Paragraph style={{ textAlign: 'left' }}>
        {pending?.description}
      </Paragraph>
      <Paragraph style={{ textAlign: 'left', paddingBottom: '48px' }}>
        {failed?.moreInfo}
        <CustomLink
          href={`${links?.support?.url}?subject=Support for Order ID ${txid}`}
        >
          {links?.support?.title}
          {/* <FormattedMessage id="thank-you.links.support.title" /> */}
        </CustomLink>
      </Paragraph>
    </>
  );
};

export const query = graphql`
  fragment ThankYouPending on Json {
    pending {
      title
      description
    }
  }
`;

export default Pending;
